import * as React from 'react';
import * as Primitive from './primitives/Pagination';

const PaginationItem = ({
  name = '',
  current = false,
  disabled = false,
  onChange,
  type = null,
}) => {
  const cssClass = `
    ${disabled ? 'cursor-not-allowed opacity-50 pointer-events-none' : ''}`;

  if (type === 'previous') {
    return (
      <Primitive.PaginationItem>
        <Primitive.PaginationPrevious
          className={cssClass.trim()}
          onClick={() => onChange()}
        />
      </Primitive.PaginationItem>
    );
  }

  if (type === 'next') {
    return (
      <Primitive.PaginationItem>
        <Primitive.PaginationNext
          className={cssClass.trim()}
          onClick={() => onChange()}
        />
      </Primitive.PaginationItem>
    );
  }

  if (type === 'ellipsis') {
    return (
      <Primitive.PaginationItem>
        <Primitive.PaginationEllipsis
          className={cssClass.trim()}
          onClick={() => onChange()}
        />
      </Primitive.PaginationItem>
    );
  }

  return (
    <Primitive.PaginationItem>
      <Primitive.PaginationLink
        className={cssClass.trim()}
        onClick={() => onChange()}
        isActive={current}
      >
        {name}
      </Primitive.PaginationLink>
    </Primitive.PaginationItem>
  );
};

const RenderFirstHalfItems = ({
  intervalStart,
  edgeEntries,
  currentPageIndex,
  onChange,
  disabled = false,
}) => {
  const renderItems = [];
  const end = Math.min(edgeEntries, intervalStart);
  for (let i = 0; i < end; i++) {
    const publicPageIndex = i + 1;
    renderItems.push(
      <PaginationItem
        key={publicPageIndex}
        name={publicPageIndex}
        current={publicPageIndex === currentPageIndex}
        onChange={() => onChange(publicPageIndex)}
        disabled={disabled}
      />
    );
  }
  if (edgeEntries < intervalStart) {
    renderItems.push(
      <PaginationItem key="first_indicator" type="ellipsis" disabled={true} />
    );
  }
  return renderItems;
};

const RenderMiddleItems = ({
  intervalStart,
  intervalEnd,
  currentPageIndex,
  onChange,
  disabled = false,
}) => {
  const renderItems = [];
  for (let i = intervalStart; i < intervalEnd; i++) {
    const publicPageIndex = i + 1;
    renderItems.push(
      <PaginationItem
        key={publicPageIndex}
        name={publicPageIndex}
        current={publicPageIndex === currentPageIndex}
        onChange={() => onChange(publicPageIndex)}
        disabled={disabled}
      />
    );
  }
  return renderItems;
};

const RenderSecondHalfItems = ({
  intervalEnd,
  edgeEntries,
  pageCount,
  currentPageIndex,
  onChange,
  disabled = false,
}) => {
  const renderItems = [];
  if (pageCount - edgeEntries > intervalEnd) {
    renderItems.push(
      <PaginationItem key="second_indicator" type="ellipsis" disabled={true} />
    );
  }
  const begin = Math.max(pageCount - edgeEntries, intervalEnd);
  for (let i = begin; i < pageCount; i++) {
    const publicPageIndex = i + 1;
    renderItems.push(
      <PaginationItem
        key={publicPageIndex}
        name={publicPageIndex}
        current={publicPageIndex === currentPageIndex}
        onChange={() => onChange(publicPageIndex)}
        disabled={disabled}
      />
    );
  }
  return renderItems;
};

const Pagination = ({ model, onChange, disabled = false }) => {
  const {
    currentPageIndex,
    pageCount,
    intervalStart,
    intervalEnd,
    edgeEntries,
  } = model;

  return (
    <Primitive.Pagination className="mt-18">
      {pageCount > 1 && (
        <Primitive.PaginationContent>
          {currentPageIndex > 1 && (
            <PaginationItem
              current={false}
              disabled={disabled}
              onChange={() => onChange(currentPageIndex - 1)}
              type={'previous'}
            />
          )}
          {intervalStart > 0 && edgeEntries > 0 && (
            <RenderFirstHalfItems
              intervalStart={intervalStart}
              edgeEntries={edgeEntries}
              currentPageIndex={currentPageIndex}
              onChange={onChange}
              disabled={disabled}
            />
          )}
          <RenderMiddleItems
            intervalStart={intervalStart}
            intervalEnd={intervalEnd}
            currentPageIndex={currentPageIndex}
            onChange={onChange}
            disabled={disabled}
          />
          {intervalEnd < pageCount && edgeEntries > 0 && (
            <RenderSecondHalfItems
              intervalEnd={intervalEnd}
              pageCount={pageCount}
              edgeEntries={edgeEntries}
              currentPageIndex={currentPageIndex}
              onChange={onChange}
              disabled={disabled}
            />
          )}
          {currentPageIndex < pageCount && (
            <PaginationItem
              current={false}
              disabled={disabled}
              onChange={() => onChange(currentPageIndex + 1)}
              type={'next'}
            />
          )}
        </Primitive.PaginationContent>
      )}
    </Primitive.Pagination>
  );
};

export default Pagination;
